<form [formGroup]="form" autocomplete="off">

  <p-dialog showHeader="false" [(visible)]="display" [modal]="true" width="900" [baseZIndex]="10000"
            header="Buscador de Destinos de Control" (onShow)="showDialogMaximized(dialDetail)" #dialDetail>

      <div class="animated fadeIn">

          <div class="row">
              <div class="col-md-12">
                  
                  <div class="card card-accent-success animated fadeIn">

                      <a class="card-header-a" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                          <div class="card-header-buscador">
                              <i class="fa fa-filter"></i> Filtros
                              <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                              <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                          </div>
                      </a>

                      <div class="card-body-detalle">

                          <!-- Ocultamos solo los campos, para que estén siempre visibles los botones "Buscar y Limpiar" -->
                          <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                              <div class="row">
                                  <div class="form-group col-md-12">
                                      <label class="col-form-label" for="inpCodigo">Descripción</label>
                                      <input formControlName="Descripcion" name="Descripcion" title="" class="form-control" id="inpDescripcion" type="text" value="">
                                  </div>
                              </div>

                              <div class="row">
                                  <div class="form-group col-md-6">
                                      <label class="col-form-label required-field" for="inpPais">País</label>

                                      <ng-select loadingText="Cargando..."
                                                 [items]="listPais"
                                                 placeholder="-- Seleccione un País --"
                                                 [loading]="!listPais"
                                                 bindLabel="Descripcion"
                                                 bindValue="Id"
                                                 formControlName="IdPais"
                                                 notFoundText="País no encontrado"
                                                 [ngClass]="displayFieldCssNgSelect('IdPais')"
                                                 clearAllText="Eliminar selección">
                                      </ng-select>
                                  </div>
                                  <div class="form-group col-md-6">
                                      <label class="col-form-label" for="inpDescripcion">Identificador (Traces)</label>
                                      <input formControlName="IdentificadorTraces" name="IdentificadorTraces" title="" class="form-control" id="inpIdentificadorTraces" type="text" value="">
                                  </div>
                              </div>

                              <div class="row">
                                  <div class="form-group col-md-12">
                                      <label class="col-form-label" for="inpCodigo">Dirección</label>
                                      <input formControlName="Direccion" name="Direccion" title="" class="form-control" id="inpDireccion" type="text" value="">
                                  </div>
                              </div>

                              <div class="row">
                                  <div class="form-group col-md-6">
                                      <label class="col-form-label" for="inpCodigo">Localidad</label>
                                      <input formControlName="Localidad" name="Localidad" title="" class="form-control" id="inpLocalidad" type="text" value="">
                                  </div>
                                  <div class="form-group col-md-3">
                                      <label class="col-form-label" for="inpCodigo">Código Postal</label>
                                      <input formControlName="CodigoZip" name="CodigoZip" title="" class="form-control" id="inpCodigoZip" type="text" value="">
                                  </div>
                                  <div class="form-group col-md-3">
                                    <label class="col-form-label" for="inpActivo">Activo</label>
                                    <p-toggleButton class="form-control-togglebutton" [disabled]="true" formControlName="Activo" onLabel="Sí" offLabel="TODOS" onIcon="pi pi-check"
                                                    offIcon="pi pi-times"></p-toggleButton>
                                  </div>
                              </div>

                              <div *ngIf="!modoConsulta" class="row">
                                  <div class="col-md-12">
                                      <div class="form-group-0 float-right">

                                          <div class="btn-group">
                                              <button name="btnSearch" class="btn btn-secondary btn-sm" type="button" title="Realiza una búsqueda" (click)="onSearchButton()"><i class="fa fa-search"></i> Buscar</button>
                                          </div>

                                          <div class="btn-group">
                                              <button class="btn btn-secondary btn-sm" type="button" title="Limpia los filtros" (click)="onCleanButton()"><i class="fa fa-eraser"></i> Limpiar</button>
                                          </div>

                                      </div>
                                  </div>
                              </div>

                          </div>
                        </div>
                  </div>
              </div>
          </div>

          <!--GRID DATOS-->
          <div *ngIf="searchingButton" class="row">
              <div class="col-md-12">
                  <div>
                      <i class="fa fa-info"></i> Haga doble click para seleccionar un Destino de Control
                  </div>
                  <div class="card card-accent-success">
                      <div class="card-header-buscador">
                          <i class="fa fa-align-justify"></i> Listado de Destinos de Control
                      </div>

                      <div class="card-body">

                          <p-table #tableSearch autoLayout="true" [value]="resultDestinoControl?.ResultList" [columns]="cols"
                                   selectionMode="single" [(selection)]="selectedDestinoControl" dataKey="Id"
                                   [lazy]="true" (onLazyLoad)="onSearchLazy($event)" [paginator]="true"
                                   [rows]="resultDestinoControl?.PageSize" [totalRecords]="resultDestinoControl?.TotalCount" [loading]="loading"
                                   styleClass="table table-responsive-sm  table-sm">
                              <ng-template pTemplate="header" let-columns>
                                  <tr>
                                      <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                          {{col.header}}
                                          <p-sortIcon [field]="col.field"></p-sortIcon>
                                      </th>
                                  </tr>
                              </ng-template>
                              <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">

                                  <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex" (dblclick)="onRowDblClick($event, rowData)">
                                      <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                          <span *ngIf="col.field!=='Activo'">
                                              {{rowData[col.field]}}
                                          </span>
                                          <span *ngIf="col.field==='Activo'">
                                              {{rowData[col.field] | siNo}}
                                          </span>
                                      </td>
                                  </tr>
                              </ng-template>
                          </p-table>
                          <div class="empty-grid" *ngIf="tableSearch.totalRecords==0">No se ha encontrado ningún registro</div>
                      </div>
                  </div>
              </div>
          </div>

          <!--<p-footer>
      <button type="button" class="btn btn-secondary btn-sm" (click)="aceptDialog()"><i class="fa fa-check"></i> Aceptar</button>
      <button type="button" class="btn btn-secondary btn-sm" (click)="cancelDialog()"><i class="fa fa-times"></i> Cancelar</button>
    </p-footer>-->

      </div>

  </p-dialog>
</form>
